"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["xlink:href"];
exports.default = (0, vue_1.defineComponent)({
    __name: 'SvgSprite',
    props: {
        href: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            default: '/svg/sprite.svg',
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", null, [
                (0, vue_2.createElementVNode)("use", {
                    "xlink:href": `${__props.url}#${__props.href}`
                }, null, 8, _hoisted_1)
            ]));
        };
    }
});
